import React from 'react'
import GueastTable from './Componates/GuestListTable'
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const GuestList = () => {
  return (
    <PageBody
      card={true}
      headerchildren={
        <>
          <HeadingOne>Guest List</HeadingOne>
        </>
      }>

      {/* Table section */}
      <div className="col-12">
        <GueastTable />
      </div>
    </PageBody>
  );
};

export default GuestList;
